import axios from 'axios';
import { handleErrorResponse } from '../util/handleErrorResponse';

const apiPath = 'comExec/realestate/';
const axiosInstance = axios.create({ baseURL: apiPath });

export const aptInformationApi = async () => {
  try {
    const res = await axiosInstance.get('?action=apt_info');
    return res.data;
  } catch (err) {
    handleErrorResponse(err);
  }
};

export const tradeListApi = async (currentMenu, currentSize) => {
  try {
    const res = await axiosInstance.get(`?action=apt_area_stat&areatype=m2&type=${currentMenu}&py=${currentSize}`);
    return res.data;
  } catch (err) {
    handleErrorResponse(err);
  }
};

export const realTransactionApi = async ({ currentMenu, pyeong, year = 'all', page = 1 }) => {
  try {
    const res = await axiosInstance.get(
      `?action=apt_price&type=${currentMenu}&py=${pyeong}&year=${year}&page=${page}&row_count=5`,
    );
    return res.data;
  } catch (err) {
    handleErrorResponse(err);
  }
};
